import React from "react";

const VerticalSidenavContext = React.createContext("vertical-sidenav");
const useVerticalSidenavContext = () => React.useContext(VerticalSidenavContext);

export { VerticalSidenavContext, useVerticalSidenavContext };
